export default "__VITE_ASSET__bltvIuk___"